import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/self-inflicted-injuries.jpg";
import selfInjuries1Mp4 from '@/assets/videos/adults-symptoms/self-inflicted-injuries/self-injury-part-1.mp4';
import selfInjuries1Webm from '@/assets/videos/adults-symptoms/self-inflicted-injuries/self-injury-part-1.webm';
import selfInjuries2Mp4 from '@/assets/videos/adults-symptoms/self-inflicted-injuries/self-injury-part-2.mp4';
import selfInjuries2Webm from '@/assets/videos/adults-symptoms/self-inflicted-injuries/self-injury-part-2.webm';
import selfPoster from '@/assets/self-inflicted-injuries-poster.png';
import selfInjuryPart1Ar from '/subs/self-injury-part-1.ar.vtt';
import selfInjuryPart1En from '/subs/self-injury-part-1.en.vtt';
import selfInjuryPart2Ar from '/subs/self-injury-part-2.ar.vtt';
import selfInjuryPart2En from '/subs/self-injury-part-2.en.vtt';
import { useLocaleStore } from '@/lib/stores/localeStore';

export const Route = createFileRoute('/(content)/adults/exercises/self-inflicted-injuries/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
head: () => ({
    meta: [
      {
        title: "Self-Inflicted Injuries - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "exercises.categories.selfInflictedInjuries",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';
  const videos = [
    {
      sources: [
        { src: selfInjuries1Webm, type: 'video/webm' },
        { src: selfInjuries1Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: selfInjuryPart1Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: selfInjuryPart1En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: selfInjuries2Webm, type: 'video/webm' },
        { src: selfInjuries2Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: selfInjuryPart2Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: selfInjuryPart2En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="self-inflicted-injuries"
      titleKey="exercises.categories.selfInflictedInjuries"
      heroImage={ExerciseImage}
      poster={selfPoster}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
